import React, { FormEvent } from 'react'

import { receivingContext, ReceivingFlowController } from '../flow'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfScanField } from '../components/RfScanField'
import { RfStatusBanner } from '../components/RfStatusBanner'
import {
  DecisionActions,
  DecisionButton,
  DecisionDialog,
  DecisionNotice,
  DialogBackdrop,
  ScanForm,
  TaskHeader,
} from '../styles'

interface LineSkuScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const LineSkuScreen = ({ controller, embedded = false, onExit }: LineSkuScreenProps) => {
  const { state, dispatch } = controller

  const submitSku = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    dispatch({ type: 'submit-line-sku' })
  }

  const createVariantDialog = state.createVariantDialogOpen ? (
    <DialogBackdrop>
      <DecisionDialog role="dialog" aria-modal="true" aria-labelledby="create-variant-title">
        <h2 id="create-variant-title">Create variant?</h2>
        <p>No existing product variant matched the scanned barcode or entered SKU.</p>
        <DecisionNotice>
          Scanned barcode: {state.lineProductBarcode || 'Not provided'}
          <br />
          Entered SKU: {state.lineSku}
          <br />
          This variant will be added to the receipt and flagged for review.
        </DecisionNotice>
        <DecisionActions>
          <DecisionButton type="button" autoFocus onClick={() => dispatch({ type: 'close-create-variant-dialog' })}>
            Cancel
          </DecisionButton>
          <DecisionButton type="button" $primary onClick={() => dispatch({ type: 'confirm-create-variant' })}>
            Create variant
          </DecisionButton>
        </DecisionActions>
      </DecisionDialog>
    </DialogBackdrop>
  ) : null

  return (
    <RfShell
      title="Receiving"
      phase="Select variant"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      contextDetails={null}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      overlay={createVariantDialog}
      actions={
        <ActionButton type="submit" form="line-sku-form">
          Continue
        </ActionButton>
      }
    >
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <TaskHeader>
        <h1>Enter SKU</h1>
      </TaskHeader>
      <ScanForm id="line-sku-form" aria-label="Enter product SKU" onSubmit={submitSku}>
        <RfScanField
          label="SKU"
          value={state.lineSku}
          placeholder="Enter SKU"
          hint={state.lineProductBarcode ? `Unmatched barcode: ${state.lineProductBarcode}` : undefined}
          onChange={(sku) => dispatch({ type: 'set-line-sku', sku })}
        />
      </ScanForm>
    </RfShell>
  )
}
